import React, { Component } from 'react';

import classes from './InputMaterial.scss';

class InputMaterial extends Component {
    render() {
        return (
            <div className={classes.Input}>
                    <input
                        {...this.props}
                        ref={this.props.inputRef} 
                        readOnly={this.props.fieldtype === "datepicker" ? true : false}
                        className={[classes.InputField, this.props.label === "Card Number" ? classes.CardImage : null].join(' ')} 
                        style={{
                            textAlign: this.props.alignment === 'left' || this.props.align === 'true' ? 'left' : this.props.alignment === 'right' ? 'right' : null,
                            ...this.props.style
                        }}
                        />
                    <span className={classes.Bar}></span>
                    <label
                        style={{
                            right: this.props.alignment === 'right' ? '0' : null,
                            left: this.props.image === 'true' ? '4rem' : this.props.alignment === 'left' || this.props.align === 'true' ? '0' : null,
                            transformOrigin: this.props.alignment === 'left' ? 'left top 0px' : this.props.alignment === 'right' ? 'right top 0px' : null
                        }}
                        className={[classes.Label, this.props.value !== '' ? classes.LabelActive : null].join(' ')}>{this.props.label}</label>
            </div>
        );
    }
}

export default InputMaterial;


// WEBPACK FOOTER //
// ./src/components/UI/InputMaterial/InputMaterial.js